import { render } from "./common-icon.vue?vue&type=template&id=11c5b353"
import script from "./common-icon.vue?vue&type=script&lang=js"
export * from "./common-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__